'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var sortDirection = Object.freeze({
  ASC: 'ASC',
  DESC: 'DESC'
});
var _default = sortDirection;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@rapiddot/react-virtual-list/lib/table/sort_direction.js
// module id = 479
// module chunks = 0